import { Component, computed, input } from '@angular/core';
import { CounterDto, MeterType } from '@lib-ui/client';
import { CounterDescriptionPipe, ObisUnitPipe } from '@lib-ui/lib/pipes';

@Component({
  selector: 'lib-counter-info',
  templateUrl: './counter-info.component.html',
  styleUrls: ['./counter-info.component.scss'],
  standalone: true,
  imports: [
    CounterDescriptionPipe,
    ObisUnitPipe,
  ],
})
export class CounterInfoComponent {
  counters = input<CounterDto[]>([]);
  meterType = input(MeterType.Undefined);
  hasObisCode = input(false);
  hasAnyUnit = computed(() => {
    return this.counters().some((counter) => counter.obis?.unit !== undefined);
  });
}
